import axios from "axios";
import authHeader from '../../../authheader'

const EIAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/IndividualEiApplication";

const getContactInformation = (applicationId) => {
    return axios.get(`${EIAPPLICATIONURL}/contactinformation`, { headers: authHeader(), params: {applicationId} });
}
const postContactInformation = (applicationId, certDisplayName) => {
    return axios.post(`${EIAPPLICATIONURL}/contactinformation`, null, { headers: authHeader(), params: { applicationId, certDisplayName } });
}
export default {
    getContactInformation,
    postContactInformation
}